import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

class VerTiUn2 extends React.Component {
    state={
        argsDocum: {
            descrTipoUnd: this.props.idLista.descrTipoUnd,
            _id: this.props.idLista._id
        },
        confirmaAct: false,
        open: false
    }

    handleChange = (ev) => {
        if (this.props.permiteUpdate){
            this.setState({confirmaAct: false})
            // if(ev.target.name !== "codigoTipoUnd"){
                const argsDocum = this.state.argsDocum
                argsDocum[ev.target.name] = ev.target.value
                this.setState({argsDocum});
            // }
        }
    }

    handleQuestionUpdDel = async (ev) => {
        var btnPress = await ev.target.attributes[0].value
        if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
        if(btnPress==="No"){
            this.setState({open: false})
        };
        if(btnPress==="Si"){
            this.setState({confirmaAct: true})
            this.setState({open: false})
            const myBtn = await document.getElementById("btnUpdDel");
            myBtn.click()
        }
    }

    render(){
        const {argsDocum, confirmaAct, open} = this.state;

        return(
            <div>
                <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
                    <i className="large hand point down yellow icon"></i>
                    Tipo de unidad
                </button>
                <div style={this.props.styles.box}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
                        <div className="ui one column stackable grid">
                            <div className="row container">
                                <div className="column" width="100%">
                                    <Form.Field>
                                        <label style={this.props.styles.label}>Descripción</label>
                                        <Form.Input autoComplete="off" name="descrTipoUnd" id="descrTipoUnd" value={this.props.permiteUpdate?argsDocum.descrTipoUnd:this.props.idLista.descrTipoUnd} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrTipoUnd'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                    </Form.Field>
                                    <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>

                                {
                                    this.props.errors.length?<Message negative header="Los siguientes errores:"
                                    list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }

                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default VerTiUn2
